module.exports = __webpack_public_path__ + "img/subtitle-618.1a8bf730.png";